import React, {useState} from 'react';
import AgreementComponent from "../register/AgreementComponent";

function ModalAgreementForm(props) {
    const [ userAgreementAccepted, updateUserAgreementAccepted ] = useState(false);

    function toggleAgreementAccepted() {
        updateUserAgreementAccepted(!userAgreementAccepted);
    }

    return (
        <React.Fragment>
            <span className="close" onClick={props.closeModal}>&times;</span>
            <AgreementComponent formClass={"group_container"} userAgreementAccepted={userAgreementAccepted} handleToggleUserAgreementAccepted={toggleAgreementAccepted} disabled={false}/>
            <div className="modal-content__actions modal-content__actions--center pb-xl">
                <input className={"modal-content__actions__btn modal-content__actions__btn--filledBlue " + (userAgreementAccepted ? "" : "modal-content__actions__btn--disabled")}
                       type="button"
                       disabled={!userAgreementAccepted}
                       onClick={props.agreementConfirmFunction}
                       value="Confirm"/>
            </div>
        </React.Fragment>
    );
}

export default ModalAgreementForm;